import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';

import { TextBlock } from '../styles/TextBlock';

function SectionAboutUs({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Section
      backgroundColor="#657888"
      backgroundImageUrl={{
        xs: {
          '1x': 'challenge-the-system/challenge-the-system-xs@1x.jpg',
          '2x': 'challenge-the-system/challenge-the-system-xs@2x.jpg',
          '3x': 'challenge-the-system/challenge-the-system-xs@3x.jpg',
        },
        md: {
          '1x': 'challenge-the-system/challenge-the-system-md@1x.jpg',
          '2x': 'challenge-the-system/challenge-the-system-md@2x.jpg',
          '3x': 'challenge-the-system/challenge-the-system-md@3x.jpg',
        },
        lg: {
          '1x': 'challenge-the-system/challenge-the-system-lg@1x.jpg',
          '2x': 'challenge-the-system/challenge-the-system-lg@2x.jpg',
          '3x': 'challenge-the-system/challenge-the-system-lg@3x.jpg',
        },
      }}
    >
      <TextBlock>
        <Typography
          variant="title"
          color="white"
          gutterBottom={2}
          intlKey={`cms.homePage.homeCardsArea.${index}.cardTitle`}
          whiteSpace="pre-line"
        />

        <Link
          href={formatMessage({ id: `cms.homePage.homeCardsArea.${index}.cardCtaLink` })}
          variant="action"
          color="white"
          intlKey={`cms.homePage.homeCardsArea.${index}.cardCtaText`}
        />
      </TextBlock>
    </Section>
  );
}

SectionAboutUs.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionAboutUs);
